import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=8fdefab2&scoped=true"
var script = {}
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=8fdefab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdefab2",
  null
  
)

export default component.exports